import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
import video1 from "../../assets/home/DPattana Vdo.mp4";
import Services from "./Services/Services";
import AboutTheCourses from "../../assets/home/home1.jpg";
import AboutTheCenter from "../../assets/home/home2.jpg";

const Home = () => {
  const navigate = useNavigate();
  const coursesRef = useRef(null);

  const handleButtonClick = (link) => {
    navigate(link);
  };

  const scrollToCourses = () => {
    if (coursesRef.current) {
      const offset = 100;
      const topPosition = coursesRef.current.offsetTop - offset;
      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="carousel-container">
        <div className="carousel-content position-relative">
          <div className="media-box">
            <video className="video-background" autoPlay loop muted about="Dhamma Pattana Intro Video">
              <source src={video1} type="video/mp4" />
            </video>
          </div>
          <div className="position-absolute top-50 start-50 translate-middle text-center">
            <p className="dhammatext">
              VIPASSANA MEDITATION AS TAUGHT BY S.N. GOENKA IN THE TRADITION OF
              SAYAGYI U BA KHIN
            </p>
            <h1 className="text-white dhammaheading">DHAMMA PATTANA</h1>
            <p className="text-white mt-4 dhammatext">
              OFFERING VIPASSANA COURSES ESPECIALLY FOR BUSINESS EXECUTIVES,
              PROFESSIONALS, AND GOVERNMENT OFFICIALS
            </p>
            <button className="btn btn-warning mt-5" onClick={scrollToCourses}>
              LEARN MORE
            </button>
          </div>
        </div>
      </div>
      <div className="container">

        <div className="home-section-container">
          <div className="home-media-container">
            <div className="home-media-background">
              <iframe
                className="home-iframe"
                src="https://www.youtube.com/embed/P97criit1qI"
                title="Millenium World Peace Summit of Religious & Spiritual Leaders By Acharya S.N. Goenka"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen"
              ></iframe>
            </div>
          </div>
          <div className="home-text-container">
            <h5>Vipassana</h5>
            <p className="body1">
              The technique of Vipassana meditation is a practical way to
              achieve peace of mind and live a happy productive life. It is
              learned by attending a 10- day residential course with a qualified
              teacher where the student is free from distractions so that the
              reality within can be observed. This technique helps practitioners
              come out of suffering; it is non-sectarian and is suitable to all
              people regardless of religion, gender, race or nationality.
            </p>
            <p className="body1">
              Before applying to a course you should read about the technique
              and accept the code of discipline which explains what Vipassana is
              and is not, and what is expected of you when attending a course,
              which is a serious undertaking.
            </p>
            <button
              type="button"
              className=" mt-1 custom-outline-btn"
              onClick={() => handleButtonClick("./what-is-vipassana")}
            >
              Read More
            </button>
          </div>
        </div>

        <div className="home-section-container reverse">
          <div className="home-media-container">
            <div className="home-media-background">
              <img src={AboutTheCourses} alt="Dhamma Pattana" className="home-image" />
            </div>
          </div>
          <div className="home-text-container">
            <h5>Courses</h5>
            <p className="body1">
              All courses offered at the Vipassana Meditation Center, Dhamma Pattana, are conducted by assistant teachers of SN Goenka using audio and video recordings of Mr. Goenka’s instructions and discourses. All ten day courses begin the evening of the arrival day and end early morning of the departure day. There are no charges for the courses – not even to cover the cost of food and accommodation.
            </p>
            <p className="body1">
              Please note that many courses are fully booked 2-3 months in advance. We encourage you to apply early in order to allow time to make travel arrangements once registered. An application is required to register for all courses. Please apply to sit only one course at a time. Any additional applications will not be processed.
            </p>
            <button
              type="button"
              className="mt-1 custom-outline-btn"
              onClick={() => handleButtonClick("./about-us")}
            >
              Read More
            </button>
          </div>
        </div>

        <div className="home-section-container">
          <div className="home-media-container">
            <div className="home-media-background">
              <img src={AboutTheCenter} alt="Dhamma Pattana" className="home-image" />
            </div>
          </div>
          <div className="home-text-container">
            <h5>Dhamma Pattana</h5>
            <p className="body1">
              Dhamma Pattana, meaning the "Harbour of Dhamma", is located on a
              hill overlooking the beach town of Gorai, in the outer northern
              suburbs of Mumbai. It is a part of the renowned Global Pagoda
              complex that opened in 2009. Get sufficient time to practice so as
              all residential rooms are equipped with western facilities and air
              conditioning.This center provides facilities suitable to
              executives and professionals used to a different lifestyle, though
              the schedule and the teachings remain the same across the centers.
            </p>
            <p className="body1">
              Before applying to a course you should read about the technique
              and accept the code of discipline which explains what Vipassana is
              and is not, and what is expected of you when attending a course,
              which is a serious undertaking.
            </p>
            <button
              type="button"
              className="mt-1 custom-outline-btn"
              onClick={() => handleButtonClick("./about-us")}
            >
              Read More
            </button>
          </div>
        </div>
        <div className="services-container">
          <Services />
        </div>
      </div>
    </>
  );
};

export default Home;
